export default "__VITE_ASSET__BNAgn5lL__ 640w, __VITE_ASSET__CZ1ZWm2U__ 1024w, __VITE_ASSET__OUPr20mJ__ 1280w";